import { FaGlobeAmericas, FaBullseye } from "react-icons/fa";
import slider3 from "../images/sliders/slider3.jpg";

const MissionVision = () => {
  return (
    <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-t border-slate-100">
      <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-16">
        {/* Left: Text Content */}
        <div className="w-full lg:w-1/2 text-left">
          <div data-aos="fade-up">
            <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
              Corporate Direction
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
              Our Mission & Vision
            </h2>
            <p className="text-slate-500 mt-3 mb-8 text-base leading-relaxed">
              What drives us forward as a global solutions partner
            </p>
          </div>

          <div className="space-y-5">
            {/* Mission */}
            <div
              className="p-6 sm:p-7 border border-slate-200/90 rounded-2xl bg-white shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-300 flex items-start gap-5"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="w-12 h-12 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center text-blue-600 shrink-0">
                <FaGlobeAmericas className="text-2xl" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-1">Mission</h3>
                <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
                  Partnering globally to generate progress and prosperity.
                </p>
              </div>
            </div>

            {/* Vision */}
            <div
              className="p-6 sm:p-7 border border-slate-200/90 rounded-2xl bg-white shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-300 flex items-start gap-5"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="w-12 h-12 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-600 shrink-0">
                <FaBullseye className="text-2xl" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-1">Vision</h3>
                <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
                  To be leading global integrated solutions company.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Image */}
        <div
          className="w-full lg:w-1/2 flex justify-center"
          data-aos="fade-left"
        >
          <div className="relative group w-full max-w-lg">
            <div className="relative overflow-hidden rounded-3xl border border-slate-200/80 shadow-2xl bg-slate-900 aspect-[4/3]">
              <img
                src={slider3}
                alt="Garment and textile manufacturing precision"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent pointer-events-none"></div>
            </div>

            {/* Floating Corporate Badge */}
            <div className="absolute -bottom-5 -left-4 sm:left-6 bg-white/95 backdrop-blur-md shadow-xl border border-slate-100 p-4 rounded-2xl flex items-center gap-3.5">
              <div className="w-10 h-10 rounded-xl bg-red-50 border border-red-100 flex items-center justify-center text-[#EB4438] font-extrabold text-base">
                ★
              </div>
              <div>
                <p className="text-slate-900 font-bold text-xs uppercase tracking-wider">
                  Global Standards
                </p>
                <p className="text-slate-500 text-xs">
                  Precision Elastic & Garment Solutions
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
